import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { QuotesListPage } from '@/features/quotes/quotes-list-page'

export const Route = createFileRoute('/_app/recurring/')({
  staticData: { crumb: 'Recurrentes' },
  validateSearch: z.object({
    q: z.string().optional(),
    status: z.string().optional(),
    page: z.number().int().min(1).optional(),
  }),
  component: Page,
})

function Page() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  return (
    <QuotesListPage
      kind="recurring"
      search={search}
      onSearch={(patch) => navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true })}
    />
  )
}
